import React, { useState } from 'react';

import { datadogRum } from '@datadog/browser-rum';

import styled from 'styled-components';

const Drawer = styled.div`
  position: fixed;
  bottom: 0;
  width: 400px;
  height: 350px;
  background: #a5131f;
  border-radius: 3px;
  z-index: 1000;

  right: 0;
  &.out {
    right: -400px;
  }
  transition: 0.3s;
`;

const Content = styled.div`
  position: relative;
  width: 100%;
`;

const Button = styled.button`
  position: absolute;
  left: -70px;
  padding: 5px 20px;
  top: 0;
  font-size: 40px;
  background: white;
  border-radius: 5px;
  color: white;
  background: #a5131f;
`;

const Title = styled.div(({ theme }) => {
  return `
  font-size: ${theme.type.size.larger};
  color: white;
  text-align: center;
  margin-top: 20px;
  font-style: italic;
`;
});

const RestoreText = styled.span(({ theme }) => {
  return `
    font-size: ${theme.type.size.larger};
    font-style: normal;
    font-weight: bold;
    margin-left: 5px;
  `;
});

const EasterEggDrawer = (props) => {
  const [showClass, setShowClass] = useState('out');

  const toggleShowClass = () => {
    if (showClass === 'out') {
      setShowClass('in');
      datadogRum.addAction('easterEggDrawerOpen', {});
    } else {
      setShowClass('out');
    }
  };

  return (
    <Drawer className={showClass}>
      <Content>
        <Button onClick={toggleShowClass}>
          <i className="fa fa-gift"></i>
        </Button>
        <Title>
          Happy Holidays! <br /> from <RestoreText>RESTORE</RestoreText>
        </Title>
        {props.children}
      </Content>
    </Drawer>
  );
};

export default EasterEggDrawer;
